import axios from 'axios';

export default {
  state: {
    productsStyle: {},
    loading: false,
    error: null,
    productsStyleLoaded: false
  },
  mutations: {
    SET_PRODUCTS_STYLE(state, product) {
      state.productsStyle = product;
      state.productsStyleLoaded = true; // Устанавливаем флаг, что данные загружены
    },
    SET_PRODUCTS_STYLE_LOADING(state, status) {
      state.productsStyleLoading = status;
    },
    SET_PRODUCTS_STYLE_ERROR(state, error) {
      state.productsStyleError = error;
    },
    UNSET_PRODUCTS_STYLE(state) {
      state.productsStyleLoaded = false;
      state.productsStyleLoading = false;
      state.productsStyle = [];
    },
  },
  actions: {
    async fetchProductsStyle({ commit, state }, id) {
      // Проверяем, были ли категории уже загружены
      if (state.loaded && state.product) {
        //return; // Если данные уже загружены, прекращаем выполнение
      }

      try {
        commit('SET_PRODUCTS_STYLE_LOADING', true);
        // Используем относительный путь, который будет добавлен к baseURL из глобальных настроек
        const response = await axios.get('api/catalog/detail/'+id+'/recomend/');
        commit('SET_PRODUCTS_STYLE', response.data.data);
        commit('SET_PRODUCTS_STYLE_ERROR', null);
      } catch (error) {
        commit('SET_PRODUCTS_STYLE_ERROR', error.message || 'Ошибка при загрузке категорий');
        console.error('Error fetching product:', error);
      } finally {
        commit('SET_PRODUCTS_STYLE_LOADING', false);
      }
    }
  },
  getters: {
    productsStyle: state => state.productsStyle,
    productsStyleLoading: state => state.productsStyleLoading,
    productsStyleError: state => state.productsStyleError,
    productsStyleLoaded: state => state.productsStyleLoaded
  }
}